module.exports = __webpack_public_path__ + "static/media/logo.7d404f07.jpg";